import React, { useContext, useEffect, useState } from 'react'
import queryString from 'query-string'
import SubHeader from '../../../../components/WithSubHeaderBG'
import NovelList from './listing'
import CreateNew from '../CreateNew'
import { get } from '../../../../lib/api'
import GenericError from '../../../../components/GenericError'
import Loader from '../../../../components/Loader'
import { Text, Box, Button } from '../../../../designSystem'
import { handleEventLog } from '../../../../lib/utils'
import { AccountContext } from '../../../../providers/accountProvider'
import { handleNewEventLog } from '../../../../lib/utils/events'
import SubTabs from '../../../../components/SubTabs'
import { creationSubTabs } from '../../../../constants'
import { NewCreationContainer } from '../styles'
import PlusIcon from '../../../../components/Images/PlusIcon'
import useSubCreationTab from '../../../../lib/customHooks/useSubCreationTab'
// import { generateNotificationsFromBooks } from '../../../Home/helpers'       // temporarily removed

const NovelsUI = (props) => {
  const {
    history,
    location: { search }
  } = props
  const [novels, setNovels] = useState([])
  const [showLoader, setShowLoader] = useState(true)
  const [apiError, toggleApiError] = useState(false)
  const params = new URLSearchParams(window.location.search);
  const [showNewDialog, setShowNewDialog] = useState(queryString.parse(search)['open-new'] || false)
  const { tabSelected, handleTabClick } = useSubCreationTab(props.history)
  const { user,isUgcUser, isHindiUgcUser } = useContext(AccountContext)

  const fetchList = () => {
    if(tabSelected === null) return
    get('/content_api/book.creator_books', {
      params: {
        is_novel: tabSelected === 1 ? 2 : 1,
        ugc_type: isHindiUgcUser ? 'hindi' : '',
        page_no: 1,
      },
    })
      .then((response) => {
        setNovels(response.results)
        // generateNotificationsFromBooks(response.results)                  // temporarily removed
        setShowLoader(false)
      })
      .catch((err) => {
        setShowLoader(false)
        throw err
      })
  }

  useEffect(() => {
    if(isHindiUgcUser && !params.get('is_series') && !params.get('is_novel')){
      props.history.replace(`/my-creations/?${user?.source_app?.includes('pfm') ? 'is_series=1' : 'is_novel=1'}`);
    }
    fetchList()
  }, [tabSelected])

  if (showLoader) {
    return <Loader />
  }
  if (showNewDialog) {
    return <CreateNew isSeries={tabSelected === 1}/>
  }

  return (
    <>
      <GenericError show={apiError} onClose={() => toggleApiError(false)} />
      {isHindiUgcUser && <SubTabs
        tabsArray={creationSubTabs}
        selectedIndex={tabSelected}
        handleTabClick={(index) => handleTabClick(index)}
      />}
      {(novels.length > 0) ? (
        <SubHeader
          title="Novels"
        >
          <Box variant="flexCard" p={16} borderTopLeftRadius="4px" borderTopRightRadius="4px">
            <Text variant="heading">
              {(isUgcUser || params.get('is_series')) ? 'Series' : 'Novels'}
            </Text>
            {!isHindiUgcUser && <Button variant="outlinePrimary" onClick={() => {
              handleNewEventLog('novel','novels_new_novel_cta_clicked',{route : window.location.pathname + window.location.search,button:'new_novel'}, user)
              handleEventLog('novel','button_click',{route : window.location.pathname + window.location.search,button:'new_novel'})
              setShowNewDialog(true)}} >
              {isUgcUser ? 'New Series' : 'New Novel'}
            </Button>}
          </Box>
          <Box variant="hr" />
          <NovelList novels={novels} />
          {isHindiUgcUser && <NewCreationContainer onClick={() => setShowNewDialog(true)}>
            <PlusIcon fill="white"/>
            <span>New {tabSelected  === 1 ? 'Series' : 'Novel'}</span>
          </NewCreationContainer>}
        </SubHeader>
      ) : (
        <CreateNew isSeries={tabSelected === 1}/>
      )}
    </>
  )
}
export default NovelsUI
